module.exports = __webpack_public_path__ + "media/images/flags/32/South-Georgia-and-the-South-Sandwich-Islands-d004ed2c8c343883d32818146c4c5d2f.png";